
import { Component, Vue } from 'vue-property-decorator'
import { WinClientClient } from '@/api'
import WinClientEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'

@Component({
  name: 'WinClientList',
  components: {
    WinClientEditor
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new WinClientClient()
    this.listQuery = {
      filter: {
        where: { version: { like: '' } },
        fields: {
          id: true,
          version: true,
          url: true,
          changelog: true,
          mandatory: true,
          createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt DESC']
      }
    }
  }

  async created() {
    super.created()
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.version.like = `%${this.listQuery.filter.where.version.like}%`
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: any) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: any) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }
}
